// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfDay as fn } from "../endOfDay.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfDayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default endOfDayWithOptions;
